<template>
  <KeysLayout :width="width" :height="height" v-slot="s">
    <template v-for="(k, id) in s.keys" :key="id">
      <KeyCap
        :row="k.row"
        :col="k.col"
        :x="k.key.x"
        :y="k.key.y"
        :rot="k.key.rot"
        :height="k.key.size.y"
        :width="k.key.size.x"
        :outlined="isSelected(k.row, k.col)"
        :blank="true"
        @click="$emit('keyClicked', k.row, k.col)"
        @mouseenter="(e) => onMouseEnter(e, k.row, k.col)"
      />
    </template>
  </KeysLayout>
</template>

<script setup lang="ts">
import KeysLayout from "@/components/utils/KeysLayout.vue";
import KeyCap from "@/components/keys/KeyCap.vue";

defineProps<{
  isSelected: (row: number, col: number) => boolean;
  height: number;
  width: number;
}>();
const emit = defineEmits<{
  (_e: "keyClicked", _row: number, _col: number): void;
}>();

// Allow to just press mouse button and slide over keys
const onMouseEnter = (e: MouseEvent, row: number, col: number) => {
  const left_pressed = (e.buttons & 1) != 0;
  if (left_pressed) emit("keyClicked", row, col);
};
</script>
